<template>
  <v-app-bar v-if="needHeader"
             ref="header"
             v-mutate="onMutate"
             app
             :absolute="!fullscreen"
             :src="headerBackground"
             :shrink-on-scroll="showcase && fullscreen"
             :prominent="showcase && fullscreen"
             :dark="dark"
             :color="color"
             :elevation="elevation"
  >
    <v-img v-if="settings.file_logo"
           :src="$essentia.filePath(settings.file_logo)"
           height="50"
           max-width="50"
    />
    <v-spacer />
    <div v-if="putHeaderContacts" class="d-flex flex-column">
      <v-chip v-if="settings.phone" class="text-no-wrap text-right mb-1" small dark>
        <v-icon small left>
          mdi-phone
        </v-icon>{{ settings.phone }}
      </v-chip>
      <v-chip v-if="settings.email" small class="text-no-wrap text-right" dark>
        <v-icon small left>
          mdi-email
        </v-icon>{{ settings.email }}
      </v-chip>
    </div>
    <template v-if="gradient && headerBackground" v-slot:img="{props}">
      <v-img v-bind="props" :gradient="gradient" />
    </template>
    <template v-slot:extension>
      <span class="text-no-wrap text-subtitle-1">
        <NavigationButton :dark="dark" position="header-left" />
        {{ putHeaderName ? settings.name : null }}
      </span>
    </template>
  </v-app-bar>
</template>

<script>
import NavigationButton from '@/components/NavigationButton';
export default {
  name: 'Header',
  components: { NavigationButton },
  props: {},
  computed: {
    elevation() { return this.$store.state.theme.headerElevation; },
    dark() { return this.$store.state.theme.headerDark; },
    color() { return this.$store.state.theme.headerColor; },
    fullscreen() { return this.$store.state.ui.fullscreen; },
    putHeaderName() {
      return !this.settings.disable_header_name && this.settings.name;
    },
    putHeaderContacts() {
      return !this.settings.disable_header_contacts && (this.settings.phone || this.settings.email);
    },
    settings() { return this.$store.state.data.settings; },
    showcase() { return this.$route.name === 'showcase'; },
    headerBackground() {
      if (this.settings.file_background) {
        return this.$essentia.filePath(this.settings.file_background);
      }
      return null;
    },
    needHeader() {
      return this.putHeaderName || this.putHeaderContacts || this.headerBackground;
    },
    gradient() {
      if (!this.$store.state.theme.headerGradient) return null;
      let gradient = '';
      if (!this.color) {
        if (this.dark) gradient = 'rgba(60,60,60,0.9), rgba(0,0,0,0.0)';
        if (!this.dark) gradient = 'rgba(255,255,255,0.9), rgba(255,255,255,0.0)';
      } else {
        if (this.dark) gradient = `${this.color}, rgba(0,0,0,0.0)`;
        if (!this.dark) gradient = `${this.color}, rgba(255,255,255,0.0)`;
      }
      return `to top right, ${gradient}`;
    }
  },
  mounted() {
    this.onMutate();
  },
  methods: {
    navigation() {
      const { navigation } = this.$store.state.ui;
      this.$store.commit('ui/navigation', !navigation);
    },
    onMutate() {
      if (this.$refs && this.$refs.header && this.$refs.header.$el) {
        this.$store.commit('ui/headerHeight', this.$refs.header.$el.offsetHeight);
      }
    }
  }
};
</script>
